module.exports = __webpack_public_path__ + "img/home-3.0b60fcbd.png";